angular.module("events")

    .controller("GuestSpaceZonesModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'event_guest_zone', 'event_guest_id', 'spaces', 'logService',
        function (LoginService, $scope, $uibModalInstance, event_guest_zone, event_guest_id, spaces, logService) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = true;

        $scope.spaces = spaces;

         $scope.data = {
             spaceSelected: null,
             FK_events_guests_zones_events_spaces_zones: null,
         };
         
        if (angular.isUndefined(event_guest_zone)) {
             $scope.data.event_guest_zone = {};
             $scope.data.is_new = true;
             $scope.data.id = null;
        } else {

            $scope.data.id = event_guest_zone.id;

            // buscamos en el array de espacios el espacio seleccionado en la zona

            angular.forEach($scope.spaces, function (space) {

                if (space.id === event_guest_zone.FK_events_guests_zones_events_spaces_zones.event_space_id) {
                    $scope.data.spaceSelected = space;
                    angular.forEach(space.FK_events_spaces_zones_events_spaces, function (zone) {
                        if (zone.id === event_guest_zone.event_zone_id) {
                            $scope.data.event_guest_zone = zone;
                        }
                    });
                }

            });

            $scope.data.is_new = false;

        }

        $scope.clearZone = function () {

            logService.debug("He entrado aquí");
            $scope.data.event_guest_zone = null;
        };

        $scope.saveGuestSpaceZones = function () {
            $uibModalInstance.close($scope.data);
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

     }])